export const LOGO_URL =
  "https://www.google.com/imgres?q=swiggy%20logo&imgurl=https%3A%2F%2Fupload.wikimedia.org%2Fwikipedia%2Fcommons%2Fthumb%2Fa%2Fa0%2FSwiggy_Logo_2024.webp%2F800px-Swiggy_Logo_2024.webp.png&imgrefurl=https%3A%2F%2Fcommons.wikimedia.org%2Fwiki%2FFile%3ASwiggy_Logo_2024.webp&docid=-bKmghmRd5IwMM&tbnid=bYlrofjRLQPS-M&vet=12ahUKEwjzo4ncvo6JAxXsgK8BHdEvA4kQM3oECEgQAA..i&w=800&h=233&hcb=2&ved=2ahUKEwjzo4ncvo6JAxXsgK8BHdEvA4kQM3oECEgQAA";

export const CDN_URL =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

export const ImgUrl =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

export const IMG_URL = "https://media-assets.swiggy.com/swiggy/image/upload/";

export const CARD_URL =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_288,h_360/";

export const FETCH_MENU_URL =
  "https://foodfire.onrender.com/api/menu?page-type=REGULAR_MENU&complete-menu=true&lat=12.9351929&lng=77.624480699999991&&submitAction=ENTER&restaurantId=";

export const MENU_API =
  "https://www.swiggy.com/dapi/restaurants/list/v5?lat=19.4547767&lng=72.76143499999999&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING";

  export const MENU_URL =
  "https://foodfire.onrender.com/api/menu?page-type=REGULAR_MENU&complete-menu=true&lat=12.9351929&lng=77.624480699999991&&submitAction=ENTER&restaurantId=";
